export default {
  loginHeader: {
    appName: "Ирис",

    languageTooltip: "Избиране на език",
    languages: {
      en: "Английски",
      bg: "Български",
      mk: "Македонски",
    },
  },

  loginForm: {
    title: "Ирис",
    subtitle: "Лабораторна информационна система",
    description:
      "Оптимизирайте лабораторния си работен процес с цялостно проследяване на проби, валидиране в реално време и сигурен многопотребителски достъп. Създадена за ефективност, проектирана за лабораторни специалисти.",
    loginButtonText: "Вход в Ирис",
  },
};
